import { render, staticRenderFns } from "./EvaluateMark.vue?vue&type=template&id=3629248e&scoped=true&"
import script from "./EvaluateMark.vue?vue&type=script&lang=js&"
export * from "./EvaluateMark.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateMark.vue?vue&type=style&index=0&id=3629248e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629248e",
  null
  
)

export default component.exports